import { atom } from "jotai";

export const perfilesAtom = atom([]);